// import {
//     Tabs,
//     TabsHeader,
//     TabsBody,
//     Tab,
//     TabPanel,
// } from "@material-tailwind/react";
import dayjs from 'dayjs';
// import 'moment/locale/th'

import React, { useEffect, useState } from "react";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EPWeekPicker from "./EPWeekPicker";
// import { SettingContext } from "../App";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import { setEndWeek, setStartWeek, setWeekOfYear } from "../../reducer/weekOfYearSlice";

// import { differenceInDays, subDays, addDays } from 'date-fns';

dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
// dayjs.locale("th");
// dayjs.extend(buddhistEra);

export default function TimeRangeSetting() {

    const dispatch = useDispatch();
    // const [openStart, setOpenStart] = useState(false);
    // const [openEnd, setOpenEnd] = useState(false);
    // const [weekStartSelected, setWeekStartSelected] = useState();
    // const [weekEndSelected, setWeekEndSelected] = useState();
    // const [showStartWeek, setShowStartWeek] = useState("");
    // const [showEndWeek, setShowEndWeek] = useState("");

    // const [hoverRange, setHoverRange] = useState();
    // const [selectedRange, setSelectedRange] = useState();

    // const [limitDate, setLimitDate] = useState();

    const [startWeek, setStartWeekDatePicker] = useState();
    const [endWeek, setEndWeekDatePicker] = useState();

    useEffect(() => {
        let currentDate = dayjs();
        // console.log(currentDate.day());
        currentDate = currentDate.add((currentDate.day() * -1) - 7, 'days');
        // console.log(currentDate);
        let startDate = currentDate.add(-21, 'days');

        setEndWeekDatePicker(currentDate);
        setStartWeekDatePicker(startDate);
   
        const weekOfYearStart = calWeekOfYear(startDate);
        const weekOfYearEnd = calWeekOfYear(currentDate);

        dispatch(setWeekOfYear({
            start: weekOfYearStart,
            end: weekOfYearEnd
        }));
    }, [dispatch])

    const calWeekOfYear = (date) => {
        const weekYear = date.format('YYYY-ww');
        const year = parseInt(weekYear.split('-')[0]);
        const week = parseInt(weekYear.split('-')[1]);

        const startDateWOY = date.add(date.$W * -1, "day");
        const startDateWeek = dayjs(startDateWOY.valueOf()).hour(0).minute(0).second(0).millisecond(0);

        const endDateWOY = date.add(6 - date.$W, "day");
        const endDateWeek = dayjs(endDateWOY.valueOf()).hour(23).minute(59).second(59).millisecond(999);

        return {
            week: week,
            year: year,
            from: startDateWeek.format('YYYY-MM-DD'),
            to: endDateWeek.format('YYYY-MM-DD')
        }
    }

    const handleStartWeekSelected = (newValue) => {
        if (startWeek.format('YYYY-ww') !== newValue.format('YYYY-ww')) {
            setStartWeekDatePicker(newValue.add(newValue.$W * -1, "day"));
            const weekOfYear = calWeekOfYear(newValue);
            dispatch(setStartWeek(weekOfYear));
        }
    }

    const handleEndWeekSelected = (newValue) => {
        if (endWeek.format('YYYY-ww') !== newValue.format('YYYY-ww')) {
            setEndWeekDatePicker(newValue.add(newValue.$W * -1, "day"));
            const weekOfYear = calWeekOfYear(newValue);
            dispatch(setEndWeek(weekOfYear));
        }
    }

    return (
        <>
            <Typography variant="subtitle1" sx={{
                color: 'black',
                textAlign: 'left',
                mb: '15px'
            }}>
                ช่วงเวลาการแสดงผล
            </Typography>
            <div className="grid w-full grid-cols-2 gap-2">
                {
                    endWeek !== undefined && startWeek !== undefined ?
                        <>
                            <EPWeekPicker format="ww/BBBB" label="สัปดาห์เริ่มต้น" maxDate={endWeek.add(6 - endWeek.$W, "day")} minDate={dayjs().year(2016)} onChange={handleStartWeekSelected} value={startWeek} />
                            <EPWeekPicker format="ww/BBBB" label="สัปดาห์สิ้นสุด" minDate={startWeek.add(startWeek.$W * -1, "day")} maxDate={dayjs()} onChange={handleEndWeekSelected} value={endWeek} />
                        </>
                        : <></>
                }
            </div>
        </>
    );
}
